import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import DataApi from '../../../api/data/DataApi'
import { Common } from '../../../api/data/types'
import { mapListDto } from '../../../mapping/product'
import { HttpError } from '../../../types/common'
import { showErrorToast } from '../../../utils/errors'
import { queryNames } from '../../queries'

const dataApi = DataApi.getInstance()

type Options = {
  enabled: boolean
}

export default function useGetTrainerProductList(options: Common.ListOptionsDto & Options) {
  const texts = useTranslation().t
  const key = [
    queryNames.getTrainerProductList,
    options.limit,
    options.offset
  ]
  const query = useQuery(key, async () => {
    const { data } = await dataApi.getTrainerProductList(options)
    return mapListDto(data)
  }, {
    staleTime: Infinity,
    refetchOnMount: 'always',
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })

  return query
}
